import React, {Component} from 'react';
import {AppContext} from '../../AppContext'
import {FormattedMessage} from "react-intl";

export default class SidebarToggle extends Component {

  getClassNames(isSidebarOpen) {
    return "navbar-toggle " + (!!isSidebarOpen ? '' : 'collapsed')
  }

  render() {
    return (
      <AppContext.Consumer>
        {({isSidebarOpen, toggleSidebar}) => (
          <button type="button" onClick={toggleSidebar} className={this.getClassNames(isSidebarOpen)}>
            <span className="sr-only">
              <FormattedMessage id="toggleSidebar" defaultMessage="Toggle sidebar navigation"/>
            </span>
            <span className="icon-bar"/>
            <span className="icon-bar"/>
            <span className="icon-bar"/>
          </button>
        )}
      </AppContext.Consumer>
    );
  }
}
